<template>
  <div>
    <div>
      <div class="input-upload-wrap"
        v-if="orderDetail.servCataId=='3010130'">
        <div class="upload-title">
          <base-tag label="矫治方案" class="upload-tag"></base-tag>
          <el-upload class="upload-file"
            v-if="['20','40','50'].includes(orderDetail.orderStatus)"
            action :http-request="uploadFile" :data="{objectType:'19',objectTag: orderDetail.servOrderId}"
            :before-upload="beforeUpload" :on-exceed="handleExceed"
            :auto-upload="true" :limit="5" multiple :show-file-list="false">
            <div class="upload-file-dragger" v-if="orderDetail.orderStatus == '20' || orderDetail.orderStatus == '40'">
              <i class="el-icon-upload"></i>
              <span>立即上传</span>
            </div>
          </el-upload>
        </div>
        <div class="pane-box">
          <div class="pane-download" v-for="(item, index) in designCorrectPlan" :key="index">
            <div class="down-file-wrap">
              <div class="down-file">
                <div v-if="isJson">.{{getFileType(item.url)}}</div>
                <div v-else>.{{getFileType(item)}}</div>
              </div>
              <div class="down-file-des">
                <a href="javascript:;" @click="toPPT(item)">{{ item.name }}</a>
              </div>
              <div @click="handleRemove(item.url,15,index)" class="icon" v-if="isJson">
                <i class="el-icon-circle-close"></i>
              </div>
              <div @click="handleRemove(item,15,index)" class="icon" v-else>
                <i class="el-icon-circle-close"></i>
              </div>
              <div class="down-button" @click="downFile(item.url,item.name,index)" v-if="isJson">
                <i class="el-icon-download"></i>
              </div>
              <div class="down-button"
                @click="downFile(item,renameFileName(item)+'_'+index+'.'+getFileType(item),index)" v-else>
                <i class="el-icon-download"></i>
              </div>
            </div>
          </div>
          <div class="pane-download" v-if="designCorrectPlan.length <= 0">
            <div class="no-file">
              <i class="el-icon-warning-outline"></i>
              <span>ppt格式文件</span>
              <a href="javascript:;" @click="downTemplate()" style="margin-left: 30px;color: #00A5D5;">下载模板</a>
            </div>
          </div>
        </div>
      </div>
      <div class="input-upload-wrap"
        v-if="common.serv.get(orderDetail.servCataId).isDesignData == '1'&&orderDetail.servCataId!='3010130'">
        <div class="upload-title">
          <base-tag label="设计文件" class="upload-tag"></base-tag>
          <el-upload class="upload-file" v-if="['20','40','50'].includes(orderDetail.orderStatus)"
            action :http-request="uploadFile" :data="{objectType:'11',objectTag: orderDetail.servOrderId}"
            :auto-upload="true" :limit="5" multiple :show-file-list="false" :on-exceed="handleExceed">
            <div class="upload-file-dragger" v-if="orderDetail.orderStatus == '20' || orderDetail.orderStatus == '40'">
              <i class="el-icon-upload"></i>
              <span>立即上传</span>
            </div>
          </el-upload>
        </div>
        <div class="pane-box">
          <div class="pane-download" v-for="(item, index) in designDataList" :key="index">
            <div class="down-file-wrap">
              <div class="down-file">
                <div>.{{getFileType(item.url)}}</div>
              </div>
              <div class="down-file-des">
                <a href="javascript:;" @click="to3dModel()">{{item.name}}</a>

              </div>
              <div @click="handleRemove(item.url,11,index)" class="icon">
                <i class="el-icon-circle-close"></i>
              </div>

              <div class="down-button" @click="downFile(item.url,item.name,index)">
                <i class="el-icon-download"></i>
              </div>
            </div>
          </div>

          <div class="pane-download" v-if="designDataList.length <= 0">
            <div class="no-file">
              <i class="el-icon-warning-outline"></i>
              <span>暂未上传</span>
            </div>
          </div>
        </div>
      </div>
      <div class="input-upload-wrap" v-if="common.serv.get(orderDetail.servCataId).isDesignReport == '1'">
        <div class="upload-title">
          <base-tag label="手术报告" v-if="plateShow"></base-tag>
          <base-tag label="种植导板手术规划报告(PDF格式)" class="upload-tag" v-else></base-tag>
          <el-upload class="upload-file" v-if="['20','40'].includes(orderDetail.orderStatus)" action :http-request="uploadFile"
            :data="{objectType:'12',objectTag: orderDetail.servOrderId}" :auto-upload="true" :limit="5" multiple
            :show-file-list="false" :on-exceed="handleExceed">

            <div class="upload-file-dragger" v-if="['20','40'].includes(orderDetail.orderStatus)">
              <i class="el-icon-upload"></i>
              <span>立即上传</span>
            </div>
          </el-upload>
        </div>

        <div class="pane-box">

          <div class="pane-download" v-for="(item,index) in designReportList" :key="index">

            <div class="down-file-wrap">

              <div class="down-file">
                <div v-if="isJson">.{{getFileType(item.url)}}</div>
                <div v-else>.{{getFileType(item)}}</div>
              </div>
              <div class="down-file-des">
                <a href="javascript:;" @click="toPdf(orderDetail.designReport,index)" v-if="isJson">{{item.name}}</a>
                <a href="javascript:;" @click="toPdf(orderDetail.designReport,index)"
                  v-else>{{renameFileName(item)+'_'+index+'.'+getFileType(item)}}</a>
              </div>
              <div @click="handleRemove(item.url,12,index)" class="icon">
                <i class="el-icon-circle-close"></i>
              </div>
              <div class="down-button"
                @click="downFile(item,renameFileName(item)+'_'+index+'.'+getFileType(item),index)">
                <i class="el-icon-download"></i>
              </div>
            </div>

          </div>

          <div class="pane-download" v-if="designReportList.length <= 0">

            <div class="no-file">
              <i class="el-icon-warning-outline"></i>
              <span>暂未上传</span>
            </div>

          </div>

        </div>

      </div>
      <div class="input-upload-wrap" v-if="common.serv.get(orderDetail.servCataId).isDesignGuide == '1'">

        <div class="upload-title">
          <base-tag label="钻针指南文件" v-if="plateShow"></base-tag>
          <base-tag label="器械钻针使用流程及注意事项(PDF格式)" class="upload-tag" v-else></base-tag>
          <el-upload class="upload-file" action :http-request="uploadFile" v-if="['20','40'].includes(orderDetail.orderStatus)"
            :data="{objectType:'13',objectTag: orderDetail.servOrderId}" :auto-upload="true" :limit="5" multiple
            :show-file-list="false" :on-exceed="handleExceed">
            <div class="upload-file-dragger" v-if="['20','40'].includes(orderDetail.orderStatus)">
              <i class="el-icon-upload"></i>
              <span>立即上传</span>
            </div>
          </el-upload>
        </div>

        <div class="pane-box">

          <div class="pane-download" v-for="(item,index) in designGuideList" :key="index">

            <div class="down-file-wrap">

              <div class="down-file">
                <div v-if="isJson">.{{getFileType(item.url)}}</div>
                <div v-else>.{{getFileType(item)}}</div>
              </div>
              <div class="down-file-des">
                <a href="javascript:;" @click="toPdf(orderDetail.designGuide,index)" v-if="isJson">{{item.name}}</a>
                <a href="javascript:;" @click="toPdf(orderDetail.designGuide,index)"
                  v-else>{{renameFileName(item)+'_'+index+'.'+getFileType(item)}}</a>
              </div>
              <div @click="handleRemove(item.url,13,index)" class="icon">
                <i class="el-icon-circle-close"></i>
              </div>
              <div class="down-button" @click="downFile(item.url,item.name,index)" v-if="isJson">
                <i class="el-icon-download"></i>
              </div>
              <div class="down-button"
                @click="downFile(item,renameFileName(item)+'_'+index+'.'+getFileType(item),index)" v-else>
                <i class="el-icon-download"></i>
              </div>
            </div>

          </div>

          <div class="pane-download" v-if="designGuideList.length <= 0">

            <div class="no-file">
              <i class="el-icon-warning-outline"></i>
              <span>暂未上传</span>
            </div>

          </div>

        </div>

      </div>
      <div class="input-upload-wrap" v-if="orderDetail.servCataId=='3010130'">
        <div class="upload-title">
          <base-tag label="模拟视频" class="upload-tag"></base-tag>
          <el-upload class="upload-file"
            v-if="orderDetail.orderStatus == '20' || orderDetail.orderStatus == '40' || orderDetail.orderStatus == '50'"
            action :http-request="uploadFile" :data="{objectType:'20',objectTag: orderDetail.servOrderId}"
            :before-upload="beforeUploadVideo" :on-exceed="handleExceed"
            :auto-upload="true" :limit="5" multiple :show-file-list="false">
            <div ref="uploadCnc" class="upload-file-dragger"
              v-if="orderDetail.orderStatus == '20' || orderDetail.orderStatus == '40'"
              v-show="orderDetail.servCataId=='3010130'">
              <i class="el-icon-upload"></i>
              <span>立即上传</span>
            </div>
          </el-upload>
        </div>
        <div class="pane-box">
          <div class="pane-box">
            <div class="pane-download" v-for="(item,index) in designAnalogVideo" :key="index">
              <div class="down-file-wrap">
                <div class="down-file">
                  <div v-if="isJson">.{{getFileType(item.url)}}</div>
                  <div v-else>.{{getFileType(item)}}</div>
                </div>
                <div class="down-file-des">
                  <a v-if="isJson" @click="toView(item)">{{item.name}}</a>
                  <label v-else @click="toView(item)">{{renameFileName(item)+'_'+index+'.'+getFileType(item)}}</label>
                </div>
                <div @click="handleRemove(item.url,16,index)" class="icon">
                  <i class="el-icon-circle-close"></i>
                </div>
                <div class="down-button" @click="downFile(item.url,item.name,index)" v-if="isJson">
                  <i class="el-icon-download"></i>
                </div>
                <div class="down-button"
                  @click="downFile(item,renameFileName(item)+'_'+index+'.'+getFileType(item),index)" v-else>
                  <i class="el-icon-download"></i>
                </div>
              </div>
            </div>
            <div class="pane-download" v-if="designAnalogVideo.length <= 0">
              <div class="no-file">
                <i class="el-icon-warning-outline"></i>
                <span>mp4格式文件</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="input-upload-wrap" v-if="orderDetail.servCataId=='3010130'">
        <div class="upload-title">
          <base-tag label="CNC制造文件" class="upload-tag"></base-tag>
          <el-upload class="upload-file" v-if="['20','40','50'].includes(orderDetail.orderStatus)"
            action :http-request="uploadFile" :data="{objectType:'14',objectTag: orderDetail.servOrderId}"
            :auto-upload="true" :limit="5" multiple :show-file-list="false" :on-exceed="handleExceed">
            <div ref="uploadCnc" class="upload-file-dragger"
              v-if="orderDetail.orderStatus == '20' || orderDetail.orderStatus == '40'">
              <i class="el-icon-upload"></i>
              <span>立即上传</span>
            </div>
          </el-upload>
        </div>
        <div class="pane-box">
          <div class="pane-download">
            <div class="no-file">
              <span>请上传stl制造文件，压缩为一个文档上传。</span>
              <span style="margin-left: 50px;color: #00A5D5;">
                总计:
                <input v-model="bracesCount"
                  style="border-bottom: 1px solid #00A5D5;background: #ECECEC;width:50px;text-align: center;">副
              </span>
            </div>
          </div>
          <div class="pane-box">
            <div class="pane-download" v-for="(item,index) in designMakeList" :key="index">
              <div class="down-file-wrap">
                <div class="down-file">
                  <div v-if="isJson">.{{getFileType(item.url)}}</div>
                  <div v-else>.{{getFileType(item)}}</div>
                </div>
                <div class="down-file-des">
                  <a @click="to3dModel" v-if="item.name.substring(item.name.lastIndexOf('.')+1)=='stl'">{{ item.name }}</a>
                  <label v-else-if="isJson">{{item.name}}</label>
                </div>
                <div @click="handleRemove(item.url,14,index)" class="icon">
                  <i class="el-icon-circle-close"></i>
                </div>
                <div class="down-button" @click="downFile(item.url,item.name,index)" v-if="isJson">
                  <i class="el-icon-download"></i>
                </div>
                <div class="down-button"
                  @click="downFile(item,renameFileName(item)+'_'+index+'.'+getFileType(item),index)" v-else>
                  <i class="el-icon-download"></i>
                </div>
              </div>
            </div>
            <div class="pane-download" v-if="designMakeList.length <= 0">
              <div class="no-file">
                <i class="el-icon-warning-outline"></i>
                <span>暂未上传</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="input-upload-wrap" v-if="orderDetail.servCataId!=='3010130'">
        <div class="upload-title">
          <base-tag label="制造文件" class="upload-tag" v-if="plateShow"></base-tag>
          <base-tag label="种植导板制造文件" class="upload-tag" v-else></base-tag>
          <el-upload class="upload-file"
            v-if="['20','40','50'].includes(orderDetail.orderStatus)"
            action :http-request="uploadFile" :data="{objectType:'14',objectTag: orderDetail.servOrderId}"
            :auto-upload="true" :limit="5" multiple :show-file-list="false" :on-exceed="handleExceed">
            <div class="upload-file-dragger" v-if="orderDetail.orderStatus == '20' || orderDetail.orderStatus == '40'">
              <i class="el-icon-upload"></i>
              <span>立即上传</span>
            </div>
          </el-upload>
        </div>
        <div class="pane-box">
          <div class="pane-download" v-for="(item,index) in designMakeList" :key="index">
            <div class="down-file-wrap">
              <div class="down-file">
                <div>.{{getFileType(item.url)}}</div>
              </div>
              <div class="down-file-des">
                <a @click="to3dModel" v-if="item.name.substring(item.name.lastIndexOf('.')+1)=='stl'">{{item.name}}</a>
                <label v-else>{{item.name}}</label>
              </div>
              <div @click="handleRemove(item.url,14,index)" class="icon">
                <i class="el-icon-circle-close"></i>
              </div>
              <div class="down-button" @click="downFile(item.url,item.name,index)">
                <i class="el-icon-download"></i>
              </div>
            </div>
          </div>
          <div class="pane-download" v-if="designMakeList.length <= 0">
            <div class="no-file">
              <i class="el-icon-warning-outline"></i>
              <span>暂未上传</span>
              <span class="upload-prompt">请回传修复体切削文件，边缘线文件（螺丝孔文件）</span>
            </div>
          </div>
        </div>
      </div>
      <div class="input-upload-wrap" v-if="orderDetail.servCataId=='3010130'">
        <div class="upload-title">
          <base-tag label="设计方案源文件" class="upload-tag"></base-tag>
          <el-upload class="upload-file"
            v-if="orderDetail.orderStatus == '20' || orderDetail.orderStatus == '40' || orderDetail.orderStatus == '50'"
            action :http-request="uploadFile" :data="{objectType:'11',objectTag: orderDetail.servOrderId}"
            :auto-upload="true" :limit="5" multiple :show-file-list="false" :on-exceed="handleExceed">
            <div class="upload-file-dragger" v-if="orderDetail.orderStatus == '20' || orderDetail.orderStatus == '40'">
              <i class="el-icon-upload"></i>
              <span>立即上传</span>
            </div>
          </el-upload>
        </div>
        <div class="pane-box">
          <div class="pane-download" v-for="(item, index) in designDataList" :key="index">
            <div class="down-file-wrap">
              <div class="down-file">
                <div v-if="isJson">.{{getFileType(item.url)}}</div>
                <div v-else>.{{getFileType(item)}}</div>
              </div>
              <div class="down-file-des">
                <a href="javascript:;" style="color: #606266;" v-if="item.name.substring(item.name.lastIndexOf('.')+1)!='stl'">{{ item.name }}</a>
                <a href="javascript:;" @click="to3dModel()" v-else-if="isJson">{{item.name}}</a>
              </div>
              <div @click="handleRemove(item.url,11,index)" class="icon" v-if="isJson">
                <i class="el-icon-circle-close"></i>
              </div>
              <div @click="handleRemove(item,11,index)" class="icon" v-else>
                <i class="el-icon-circle-close"></i>
              </div>
              <div class="down-button" @click="downFile(item.url,item.name,index)" v-if="isJson">
                <i class="el-icon-download"></i>
              </div>
              <div class="down-button"
                @click="downFile(item,renameFileName(item)+'_'+index+'.'+getFileType(item),index)" v-else>
                <i class="el-icon-download"></i>
              </div>
            </div>
          </div>
          <div class="pane-download" v-if="designDataList.length <= 0">
            <div class="no-file">
              <i class="el-icon-warning-outline"></i>
              <span>暂未上传</span>
              <span class="upload-prompt">压缩包/3sz格式文件</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 临时引用orderRemark -->
    <div class="input-upload-wrap" v-if="( orderDetail.orderStatus == '20' || orderDetail.orderStatus == '40')" >
      <base-tag label="留言信息"></base-tag>
      <div class="temp" style="padding: 10px;">
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 20 }"
          placeholder="可选填，填写提示下单方注意的相关信息"
          v-model="designRemark" />
      </div>
    </div>
    <div class="design-confirm-btn" v-if="orderStatus == '20' || orderStatus == '40'">
      <y-button text="立即提交" classStyle="main-btn ml" @btnClick="clickSubmit" />
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {uploadByPieces} from "../../../common/upload.js";
  import md5 from 'js-md5' //引入MD5加密
  import BaseTag from '/components/BaseTag'
  import YButton from '/components/YButton'
  export default {
    props: {
      orderDetail: {
        type: Object,
        default: null
      },
      report: {
        type: String,
      },
      guide: {
        type: String,
      }
    },
    computed: {
      ...mapState(['common', 'user'])
    },
    data() {
      return {
        designDataList: [], //设计文件
        designMakeList: [], //制造文件
        designReportList: [], //手术报告
        designGuideList: [], //钻针指南文件
        designCorrectPlan: [], //矫治方案
        designAnalogVideo: [],//模拟视频
        plateShow: true,
        isJson: false, //传入数据是否是json字符串
        orderStatus: '',
        designRemark:'',//设计师留言
        bracesCount: 0,//正畸牙套数量
        showView: false,//
      }
    },
    methods: {
      clickSubmit(){
        sessionStorage.setItem('orderId',this.orderDetail.servOrderId)
        this.$confirm('确定提交以上文件？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(() => {
          this.submitDesign();
        }).catch(() => {});
      },
      submitDesign() {
        this.loading = true
        if(
          this.showMsg(['1010698','1010699'],this.designReportList,'种植导板手术规划报告不能为空',false)&&
          this.showMsg(['1010698','1010699'],this.designGuideList,'器械钻针使用流程及注意事项不能为空',false)&&
          this.showMsg(['1010698','1010699'],this.designDataList,'设计文件不能为空',true)&&
          this.showMsg([],this.designMakeList,'制造文件不能为空',true)&&
          this.showMsg(['3010130'],this.designCorrectPlan,'矫治方案不能为空',false)&&
          this.showMsg(['3010130'],this.designAnalogVideo,'模拟视频不能为空',false)
        ){
          if(this.bracesCount==0&&this.orderDetail.servCataId=='3010130'){
            this.$message({
              type:'error',
              message:'请输入牙套数量'
            })
            return false
          }
          this.$api.post({
            url: '/biz/orderServ/des/submit',
            data: {
              servOrderId: this.orderDetail.servOrderId,
              designData: JSON.stringify(this.designDataList),
              designMake: JSON.stringify(this.designMakeList),
              designReport: JSON.stringify(this.designReportList),
              designGuide: JSON.stringify(this.designGuideList),
              designCorrectPlan: JSON.stringify(this.designCorrectPlan),
              designAnalogVideo: JSON.stringify(this.designAnalogVideo),
              designRemark: this.designRemark,
              bracesCount: this.bracesCount
            },
          }).then(res => {
            this.loading = false
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '提交成功'
              });
              this.orderStatus = res.data.orderStatus;
              this.$emit('update:orderDetail', res.data);
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
          })
        }else{
          console.log('提交失败')
          return false
        }
        this.loading = false
      },
      checkFile(list,msg){
        let id = this.orderDetail.servCataId;
        if(list.length){
          this.$message({
            type:'error',
            message:msg
          })
        }
      },
      // submitDesign提交表单的验证提示 文件列表不为空
      showMsg(idList,list,msg,flag){
        let id = this.orderDetail.servCataId;
        let temp = idList.includes(id)
        if(flag){
          temp = !idList.includes(id)
        }
        if(temp&&list.length==0){
          this.$message({
            type:'error',
            message:msg
          })
          return false
        }else{
          return true
        }
      },
      //push文件，如果name/file其中一项为空则不加入
      pushFile(item,dataList){
        console.log('name:',item.name,'url:',item.url);
        if(item.name&&item.url){
          dataList.push(item);
        }else{
          this.$message({
            type: 'warning',
            message: '文件信息缺失，请确定对应文件，重新上传！'
          });
        }
        console.log('dataList:',dataList);
      },
      // 上传文件
      async uploadFile({response,file,data}) {
        // console.log('response:',response)
        // console.log('file:',file)
        // console.log('data:',data)
        var loading = this.$loading({
          text: '等待上传完成，已上传 0%'
        });
        var that = this
        uploadByPieces({
          file: file, // 文件
          data: data,
          pieceSize: 3, // 分片大小
          concurrent: 3,
          process: res => {
            loading.setText('等待上传完成，已上传' + res + '%')
            // console.log('分片上传 -> process', res)
            if (res == 100) {
              loading.close();
            }
          },
          success: res => {
            if (data.objectType == '11') { //设计文件
              let resData = {}
              resData.name = file.name;
              resData.url = res.data.url;
              this.pushFile(resData,this.designDataList);
            } else if (data.objectType == '12') { //手术文件
              let resData = {}
              resData.name = file.name;
              resData.url = res.data.url;
              this.pushFile(resData,this.designReportList);
            } else if (data.objectType == '13') { //器械钻针使用流程及注意事项
              let resData = {}
              resData.name = file.name;
              resData.url = res.data.url;
              this.pushFile(resData,this.designGuideList);
            }else if (data.objectType == '14') { //制造文件
              let resData = {}
              resData.name = file.name;
              resData.url = res.data.url;
              this.pushFile(resData,this.designMakeList);
            }else if(data.objectType == '19'){//矫治方案
              let resData = {}
              resData.name = file.name;
              resData.url = res.data.url;
              this.pushFile(resData,this.designCorrectPlan);
            }else if(data.objectType == '20'){//模拟视频
              let resData = {}
              resData.name = file.name;
              resData.url = res.data.url;
              this.pushFile(resData,this.designAnalogVideo);
            }
            loading.close();
            // console.log('分片上传 -> success', res)
          },
          error: e => {
            loading.close();
            // console.log('分片上传 -> error', e)
          }
        })
      },
      to3dModel() {
        let routeUrl = this.$router.resolve({path: '/3Dmodel', query: {orderId: this.orderDetail.servOrderId}})
        window.open(routeUrl.href, '_blank');
      },
      toPPT(item){
        if(item.name.substring(item.name.lastIndexOf('.')+1)=='pdf'){
          this.$router.push({
            name: 'pdfPreview',
            params: {
              url: item.url
            }
          })
        }else{
          // 使用 Office Online 预览
          const officeOnlineUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(item.url)}`;
          window.open(officeOnlineUrl, '_blank');
        }
      },
      toView(item) {
        let videoUrl = item.url;
        const htmlContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Video Player</title>
        </head>
          <style>
            body {
              margin: 0;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              background-color: #000;
            }
            video {
              width: 100%;
              height: auto;
              max-width: 100%;
              max-height: 100%;
            }
          </style>
        <body>
          <video controls>
            <source src="${videoUrl}" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </body>
        </html>
      `;

        const blob = new Blob([htmlContent], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      },
      // 下载模板
      downTemplate() {
        // 正畸下载模版 --- 医小智正畸报告模版.rar
        let url = "https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/user/order/20039871/20240923_2010120_test/scan/3573f726554c7d3ce2ab4a40592ea545.rar";
        var loading = this.$loading({
          text: '正在下载，已下载 0%'
        });
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        // 监听进度事件
        xhr.onprogress = function (e) {
          if (e.lengthComputable) {
            const percentComplete = (e.loaded / e.total) * 100;
            loading.setText('正在下载，已下载' + percentComplete.toFixed(2) + '%')
            if (percentComplete == 100) {
              loading.close();
            }
            // 更新你的加载指示器
          }
        }
        xhr.onload = function () {
          if (this.status === 200) {
            const blob = this.response;
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = blobUrl;
            a.download = '医小智正畸报告模版.rar';
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(blobUrl);
            // 隐藏或重置加载指示器
          }
        }
        xhr.onerror = function () {
          console.error('Error downloading the file.');
          // 处理错误，隐藏或重置加载指示器
        }
        xhr.send();
      },
      handleRemove(file,type,index) {
        let tempData = ''
        if (type==11) {
          tempData = this.designDataList;
        }else if (type==12) {
          tempData = this.designReportList;
        }else if (type==13) {
          tempData = this.designGuideList;
        }else if(type==14) {
          tempData = this.designMakeList;
        }else if(type==15){
          tempData = this.designCorrectPlan;
        }else if(type==16){
          tempData = this.designAnalogVideo;
        }
        if(tempData=='') {
          this.$message("数据错误！！")
          return false
        }
        this.$confirm('确定移除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
         }).then(() => {
          tempData.splice(index,1)
          this.$message({
            type: 'success',
            message: '移除成功!'
          });
         });
      },
      toPdf(tempUrl,index) {
        var url = JSON.parse(tempUrl);
        this.$router.push({
          name:'pdfPreview',
          params:{
            url:url[index].url
          }
        })
      },
      downFile(url,fileName,index){
        const x = new XMLHttpRequest()
        x.open('GET', url, true)
        x.responseType = 'blob'
        x.onload = function() {
          const url = window.URL.createObjectURL(x.response)
          const a = document.createElement('a')
          a.href = url
          a.download = fileName
          a.click()
        }
        x.send()
      },
      clickUpload(index){
        this.fileIndex = index;
        this.$refs.uploadCnc.click();
      },
      beforeUpload(file){
      //判断文件类型
        let fileName = file.name;
        console.log('fileName',fileName)
        let reg = /^.+\.(ppt|pptx|ppsx|ppsm|pot|potm)$/;
        if(!reg.test(fileName)){
          this.$message.error("只能上传ppt文件！");
          return false;
        }
        return true;
      },
      beforeUploadVideo(file){
        //判断文件类型
        let fileName = file.name;
        console.log('fileName',fileName)
        let reg = /^.+\.(mp4)$/;
        if(!reg.test(fileName)){
          this.$message.error("只能上传.mp4文件！");
          return false;
        }
        return true;
      },
      handleExceed(){
        this.$message({
          type: 'error',
          message: '最多支持5个文件上传，上传数量大于5请打包上传'
        })  
      }
    },
    mounted() {
      try{
        this.designDataList = this.orderDetail.designData.length ? JSON.parse(this.orderDetail.designData) : [];
        this.designMakeList = this.orderDetail.designMake.length ? JSON.parse(this.orderDetail.designMake) : [];
        this.designGuideList = this.orderDetail.designGuide.length ? JSON.parse(this.orderDetail.designGuide) : [];
        this.designReportList = this.orderDetail.designReport.length ? JSON.parse(this.orderDetail.designReport) : [];
        if (this.orderDetail.servCataId=='3010130') {
          this.designAnalogVideo = this.orderDetail.orthodonticsData.designAnalogVideo.length ? JSON.parse(this.orderDetail.orthodonticsData.designAnalogVideo) : [];
          this.designCorrectPlan = this.orderDetail.orthodonticsData.designCorrectPlan.length ? JSON.parse(this.orderDetail.orthodonticsData.designCorrectPlan) : [];
          this.bracesCount = this.orderDetail.servCataId == '3010130' ? this.orderDetail.orthodonticsData.bracesCount : 0;
        }
        this.isJson = true
      }catch(e){
        this.isJson = false
        this.designDataList = this.orderDetail.designData.length != 0 ? this.orderDetail.designData.split(",") : [];
        this.designMakeList = this.orderDetail.designMake.length != 0 ? this.orderDetail.designMake.split(",") : [];
        this.designGuideList = this.orderDetail.designGuide.length != 0 ? this.orderDetail.designGuide.split(",") : [];
        this.designReportList = this.orderDetail.designReport.length != 0 ? this.orderDetail.designReport.split(",") : [];
      }
    },
    created() {
      if(this.orderDetail.servCataId == '1010698'||
         this.orderDetail.servCataId == '1010699'){
        this.plateShow = false
      }
      this.orderStatus = this.orderDetail.orderStatus
    },
    components: {
      BaseTag,
      YButton
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/mixin";

  .pane-box {}

  .pane-label {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 32px;

    div {
      width: 5px;
      height: 14px;
      border-radius: 2px;
      background-color: #00a5d5;
      margin-right: 10px;
    }

  }

  .pane-download {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: #ececec;
    border-radius: 5px;
    padding: 10px 15px;
    margin: 5px 0;
    position: relative;
  }

  .down-file-wrap {
    display: flex;
  }
  .icon {
    display: none;
    align-items: center;
    font-size: 22px;
    color: #f56c6c;
  }
  .pane-download:hover .icon{
    display: flex;
  }

  .down-file-des {
    display: flex;
    flex-direction: column;
    padding: 5px 20px;

    a {
      flex: 1;
      display: flex;
      align-items: center;
      font-size: 13px;
      font-weight: 500;
    }
  }
  .down-file {
    height: 60px;
    width: 60px;
    background-image: url(/static/images/file.png);
    background-size: 50px 60px;
    background-repeat: no-repeat;
    background-position: center;
    div {
      width: 100%;
      color: #f7f7f7;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      margin-top: 22px;
    }

  }

  .down-button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-size: 26px;
    width: 38px;
    height: 38px;
    position: absolute;
    left: 93%;
    top:24%;
    color: #34495e;

    &:hover {
      color: #00a5d5;
      border-color: #00a5d5;
      background-color: #E4E7ED;
    }
  }

  .pane-photo {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    background: #ececec;
    border-radius: 5px;
    padding: 10px 15px;
    margin: 5px 0;
  }

  .pane-photo-img {
    width: 60px;
    height: 60px;
    border-radius: 5px;
    margin-right: 10px;
  }

  .no-file {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 28px;

    i {
      font-size: 15px;
    }

    span {
      font-size: 13px;
      margin-left: 5px;
    }
  }

  .design-confirm-btn {
    width: 100%;
    text-align: center;
    padding: 10px;
  }

  .upload-title {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: relative;
  }

  .upload-tag {
    text-indent: 5px;
  }

  .upload-tag::before{
    content: '*';
    font-family: "宋体", Arial, sans-serif;
    color: red;
    position: absolute;
    top: 40%;
    left: 0.4%;
  }

  .upload-file {
    font-size: 22px;
    font-weight: 500;
    padding: 0 20px;

    .upload-file-dragger {
      display: flex;
      align-items: center;
      height: 34px;
      color: #00a5d5;

      span {
        font-size: 12px;
        margin-left: 5px;
      }

    }
  }
.upload-prompt{
  position: absolute;
  left: 15%;
}
.file-box{
  width: 18%;
  height: auto;
  float: left;
  border: 1px solid green;
  // margin-left: 65px;
}
</style>



// WEBPACK FOOTER //
// detailUpload.vue?2fe1a3e4